<script>
  import SaveAndReloadButton from './SaveAndReloadButton.svelte';

  let { phase } = $props();
  const loaders = {
    visualizer: () => import('./PromptVisualizer.svelte'),
    confirmation: () => import('./CombinationPreview.svelte'),
    studio: () => import('./Studio.svelte'),
    finalized: () => import('./Gallery.svelte')
  };
  const names = { visualizer: 'Visualizer', confirmation: 'combinations', studio: 'Studio', finalized: 'Gallery' };
  const component = $derived(loaders[phase]());
</script>

{#await component}
  <div class="phase-status" role="status">Loading {names[phase]}…</div>
{:then module}
  <module.default />
{:catch}
  <div class="phase-status">
    <p role="alert">Unable to load {names[phase]}. Your current work is still here.</p>
    <SaveAndReloadButton />
  </div>
{/await}

<style>
  .phase-status { padding: 2rem; text-align: center; color: var(--color-text-muted); }
</style>
